export default __webpack_public_path__ + "static/media/arrow.b852789d.svg";